export default __webpack_public_path__ + "static/media/member3.29299a40.png";